/**
 * Shared category configuration for DailyTechTrend
 * Single source of truth  used by Navbar, App.js, Footer, SEO, etc.
 */

export const CATEGORIES = [
  {
    id: 'all',
    name: 'Latest',
    description: 'All latest daily tech trends, news, and updates',
    icon: '⚡',
  },
  {
    id: 'startups',
    name: 'Startups',
    description: 'Startup profiles, funding rounds, entrepreneurship, and growth stories',
    icon: '🚀',
    matchValues: ['startups', 'startup', 'funding', 'founders'],
  },
  {
    id: 'venture',
    name: 'Venture',
    description: 'Venture capital deals, acquisitions, market trends, and investment analysis',
    icon: '💼',
    matchValues: ['venture', 'vc', 'deals', 'acquisitions', 'investments'],
  },
  {
    id: 'apple',
    name: 'Apple',
    description: 'Apple product releases, hardware reviews, iOS updates, and ecosystem news',
    icon: '🍎',
    matchValues: ['apple', 'iphone', 'mac', 'ipad', 'ios', 'macos', 'watchos'],
  },
  {
    id: 'security',
    name: 'Security',
    description: 'Cybersecurity alerts, zero-day vulnerabilities, privacy guides, and defense tactics',
    icon: '🛡️',
    matchValues: ['security', 'cybersecurity', 'vulnerability', 'privacy', 'malware', 'hack'],
  },
  {
    id: 'ai',
    name: 'AI',
    description: 'Artificial intelligence models, developer tooling, LLMs, machine learning, and ethics',
    icon: '🧠',
    matchValues: ['ai', 'artificial-intelligence', 'generative-ai', 'llm', 'machine-learning', 'deep-learning', 'openai', 'gemini', 'claude'],
  },
  {
    id: 'apps',
    name: 'Apps',
    description: 'Mobile, desktop, and web application reviews, feature breakdowns, and UX designs',
    icon: '📱',
    matchValues: ['apps', 'app', 'software', 'mobile-apps', 'reviews', 'product-hunt'],
  },
];

/**
 * Build a flat lookup: GCP category value → navbar category id
 * e.g. 'ai' → 'tech-trends', 'tutorial' → 'tech-guides'
 */
export const CATEGORY_VALUE_MAP = CATEGORIES.reduce((acc, cat) => {
  if (cat.matchValues) {
    cat.matchValues.forEach((val) => {
      acc[val.toLowerCase()] = cat.id;
    });
  }
  return acc;
}, {});

/**
 * Get display name for a category id
 */
export const getCategoryName = (id) => {
  const cat = CATEGORIES.find((c) => c.id === id);
  return cat ? cat.name : id;
};

/**
 * Get category object by id
 */
export const getCategoryById = (id) => CATEGORIES.find((c) => c.id === id) || null;
